import type { ResponseContext } from "../../../@api";

import { translationKeys } from "../../models/app-translation-keys";
import { IMiddelware } from "../../models/interfaces/middelware.interface";
import { GlobalErrorsStore } from "../../stores/GlobalErrorsStore";

export class ErrorResponseHandlingMiddleware implements IMiddelware {
  public readonly handledHttpStatusCodes = [200, 201, 202, 204];

  public readonly skipHttpStatusCodes = [401, 402, 403, 422, 429, 500, 503];

  constructor(private readonly globalErrorsStore: GlobalErrorsStore) {}

  public async post(context: ResponseContext): Promise<Response | void> {
    if (this.handledHttpStatusCodes.includes(context.response.status)) {
      // Success
      this.resetError();
    } else if (!this.skipHttpStatusCodes.includes(context.response.status)) {
      // Error
      this.setError();
    }
  }

  public resetError() {
    this.globalErrorsStore.removeError(translationKeys.globalErrors.serverConnection);
  }

  public setError() {
    this.globalErrorsStore.addErrorIfNotExists(translationKeys.globalErrors.serverConnection);
  }
}
